import axios from '../plugins/axios';

export default {
  loadOfficeInfo() {
    const url = process.env.VUE_APP_HIWORKS_OFFICE_API + `/offices/me?include=config`;

    return axios.get(url);
  },
  loadOfficeAccountInfo() {
    const url = process.env.VUE_APP_HIWORKS_OFFICE_ACCOUNT_API + `/users/me`;

    return axios.get(url);
  },
};
